module.exports = __webpack_public_path__ + "img/00 banner.72e41bc5.png";